
import useStyles from './Theme_3/ComponentCss';
import useStyle from './Theme_3/FormControlsCss';
import Header from './Theme_3/Components/Header';



const ThemeControls = {
    useStyles,
    useStyle,
    Header
}

export default ThemeControls;